<template>
  <div>
    <v-alert
      v-model="showNetworkAlert"
      type="error"
    >
      Unable to reach server. Please check your network connection and try
      again.
    </v-alert>
    <v-alert
      v-model="showDuplicateAlert"
      type="error"
    >
      Duplicate records found. Please ask for assistance.
    </v-alert>
    <v-alert
      v-model="showBadRequestAlert"
      type="error"
    >
      {{ errorMsg }}
    </v-alert>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("stakeholders", ["showNetworkAlert", "showDuplicateAlert"]),
    ...mapState("auth", ["showBadRequestAlert", "errorMsg"])
  }
};
</script>
